/** Production facilities — shared customers/products; orders/lines are facility-scoped. */

export const FACILITY_IDS = {
  CENTRAL: 'central',
  STRAWBERRY_PATCH: 'strawberryPatch'
};

export const DEFAULT_FACILITY_ID = FACILITY_IDS.CENTRAL;

export const FACILITIES = [
  {
    id: FACILITY_IDS.CENTRAL,
    label: '87 Central',
    shortLabel: '87C'
  },
  {
    id: FACILITY_IDS.STRAWBERRY_PATCH,
    label: 'Strawberry Patch',
    shortLabel: 'S. Patch'
  }
];

/** Farmstand — Strawberry Patch chrome on a dark ground (app has many hardcoded dark surfaces). */
export const SP_THEME = {
  flour: '#F7EFE1', // light type / on-dark text
  vine: '#3F5640', // panels / selected chip
  cocoa: '#17140F', // page ground (dark)
  harvest: '#DFAE4C', // primary accent / trim on dark
  cherry: '#9C2B3C', // script accent
  fonts: {
    caps: "'Oswald', 'Montserrat', sans-serif",
    script: "'Pinyon Script', cursive",
    serif: "'Source Serif 4', Georgia, serif"
  }
};

export const FACILITY_STORAGE_KEY = 'al.activeFacilityId';

export const isValidFacilityId = (id) =>
  FACILITIES.some((f) => f.id === id);

/** Missing facilityId on legacy docs ⇒ Central. */
export const resolveFacilityId = (value) => {
  if (value && isValidFacilityId(value)) return value;
  return DEFAULT_FACILITY_ID;
};

/**
 * Home facility = who the customer bought from and where they pick up
 * (emails, branding). facilityId = where it's produced. Missing ⇒ same as facilityId.
 */
export const resolveHomeFacilityId = (order) =>
  resolveFacilityId(order?.homeFacilityId || order?.facilityId);

/** Produced away from home — e.g. a Strawberry Patch order printed at 87 Central. */
export const isAwayFromHome = (order) =>
  resolveHomeFacilityId(order) !== resolveFacilityId(order?.facilityId);

export const getFacility = (id) =>
  FACILITIES.find((f) => f.id === resolveFacilityId(id)) || FACILITIES[0];

export const matchesFacility = (doc, activeFacilityId) => {
  const active = resolveFacilityId(activeFacilityId);
  const docFacility = resolveFacilityId(doc?.facilityId);
  return docFacility === active;
};

export const filterByFacility = (items, activeFacilityId) =>
  (items || []).filter((item) => matchesFacility(item, activeFacilityId));

/** printlist2Progress / lockedPrintLists doc id */
export const facilityProgressDocId = (facilityId, dateKey) =>
  `${resolveFacilityId(facilityId)}_${dateKey}`;
